import { STATIC_STRINGS } from "@asez/shared";
import ScheduleOptions from "./ScheduleOptions";

const AssignmentSchedule = () => {
  return (
    <>
      <div className="lg:text-base xl:text-lg px-2 font-semibold">
        {STATIC_STRINGS.ASSIGNMENT_SCHEDULE}
      </div>
      <ScheduleOptions />
    </>
  );
};
export default AssignmentSchedule;
